import tracker from '../../../../service/tracker';
import ACTION_TYPES from '../../../context/actionTypes';
import { getScFilterUrl } from '../../sc_tiles_carousel/utils';
import { EVENTS_MAPPING } from '../../../../utils/constants';
import { OTHER_SC_IDS } from './constants';

export const handleClick = ({ setCollapseCarousel, subCategory, selected, dispatch }) => {
    changeActiveSubcategoryContext({ subCategory, selected, dispatch });
    setCollapseCarousel(true);
    const selectedSC = subCategory.children.find((sc) => sc.params.sub_category === selected);
    const { alias, params: { sub_category } } = selectedSC;
    trackScFilter(alias, sub_category);
};

export const changeActiveSubcategoryContext = ({ subCategory, selected, dispatch }) => {
    subCategory.selected = false;
    const selectedSC = subCategory.children.find((sc) => sc.params.sub_category === selected);
    selectedSC.selected = true;
    dispatch({ type: ACTION_TYPES.SC_FILTER_APPLIED, children: subCategory.children });
};

export const trackScFilter = (alias, sub_category) => {
    const payload = {
        location: 'Top Tile',
        alias,
        scId: sub_category
    };

    tracker.trackSCFilter(EVENTS_MAPPING.FILTERS_APPLY, payload);
};

export const transformScItems = (scItems = []) => scItems.map((sc) => (
    {
        id: sc.params.sub_category,
        alias: sc.alias,
        url: getScFilterUrl(sc),
        count: sc.count
    }
));

export const sortByMostSignificant = (scItems = [], significantLeafCategories) => {
    const reversedOrder = [...significantLeafCategories].reverse();

    const sortedList = scItems.sort((a, b) => (
        reversedOrder.findIndex((k) => k === b.id) -
        reversedOrder.findIndex((i) => i === a.id)
    ));

    return moveOtherSCToLast(sortedList);
};

const moveOtherSCToLast = (sortedList) => {
    const otherScIndex = sortedList.findIndex((el) => OTHER_SC_IDS.includes(el.id));
    if (otherScIndex !== -1) {
        const option = sortedList.splice(otherScIndex, 1)[0];
        sortedList.push(option);
    }
    return sortedList;
};
